import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import logo from '../assets/images/amplify-loyalty-logo.svg';
import loadingGif from '../assets/images/loading-buffering.gif';

export default function StoreOnboarding() {
  const navigate = useNavigate();
  const { getJwtToken, setUserProfileFromResponse } = useContext(AuthContext);
  const [storeName, setStoreName] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!storeName.trim()) {
      setError('Please enter your store name.');
      return;
    }
    setSubmitting(true);
    try {
      const token = await getJwtToken();
      const res = await axios.post(
        'https://api.amplifyloyalty.com/app/onboarding/store',
        { storeName: storeName.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (setUserProfileFromResponse) {
        setUserProfileFromResponse(res.data);
      }
      navigate('/app/product-analysis/analytics', { replace: true });
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Could not create store.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ 
      height: '100vh', 
      width: '100vw',
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#000',
    }}>
      <div className="signup" style={{ 
        maxWidth: 800, 
        width: '100%',
        height: '50%',
        minHeight: 400,
        padding: '3rem 2rem',
        borderRadius: '8px',
        border: '1px solid #333',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src={logo} alt="Amplify Loyalty" style={{ height: '60px', marginBottom: '1rem' }} />
        </div>
        <h1 className="signup__header">Set up your store</h1>
        <hr className="signup__horizontal-rule" />
        <p style={{ marginBottom: '1rem' }}>
          Enter your company or store name to get started. You can connect Shopify later from Integrations.
        </p>
        <form className="auth-form signup__form" onSubmit={onSubmit}>
          <label className="signup__form-label" htmlFor="storeName">
            Store name
          </label>
          <input
            id="storeName"
            name="storeName"
            value={storeName}
            onChange={(e) => setStoreName(e.target.value)}
            disabled={submitting}
          />
          {error && <div className="form-errors">{error}</div>}
          {submitting ? (
            <div style={{ textAlign: 'center', margin: '1rem 0', padding: 0 }}>
              <img src={loadingGif} alt="loading" style={{ width: '50px', height: '50px', margin: 0 }} />
            </div>
          ) : (
            <button type="submit" className="gradient">
              Continue
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
